import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    margin: '24px auto 0px'
  },
  withErrorCode: {
    position: 'relative',
    paddingTop: '64px'
  },
  errorCode: {
    fontFamily: capitalDesignTokens.foundations.typography.baseFont,
    fontSize: '150px',
    color: capitalDesignTokens.foundations.colors.orange700,
    lineHeight: 1,
    position: 'absolute',
    top: 0
  },
  header: {
    marginTop: '48px'
  },
  supportText: {
    marginTop: '8px',
    '& a': {
      color: capitalDesignTokens.foundations.colors.gray700,
      textDecoration: 'underline'
    }
  }
});
